import { webRequest, webNoTokenRequest } from "../api";

// 新增帳單
export function createBill(data) {
  return webRequest({
    url: "/v1/oauth/management/bill/create",
    method: "post",
    data: data
  });
}

// 編輯帳單
export function updateBill(data) {
  return webRequest({
    url: "/v1/oauth/management/bill/edit",
    method: "post",
    data: data
  });
}

// 取得新增費用期數
export function getBillPeriods(params) {
  return webRequest({
    url: "/v1/oauth/management/bill/contracts/contractBillPeriods",
    method: "get",
    params: params
  });
}

// 取得編輯帳單資訊
export function getEditBill(params) {
  return webRequest({
    url: "/v1/oauth/management/bill/edit/page",
    method: "get",
    params: params
  });
}

// 合約ID取得是否有房東
export function getHouseLandlord(params) {
  return webRequest({
    url: "/v1/oauth/management/contract/getHouseLandlord",
    method: "get",
    params: params
  });
}

// 下載批量新增帳單excel
export function downloadBatchCreateBillExcel(params) {
  return webRequest({
    url: "/v1/oauth/management/bill/downloadBatchCreateBillExcel",
    method: "get",
    responseType: "blob"
  });
}

// 上傳批量新增帳單excel
export function uploadExcel(data) {
  return webRequest({
    url: "/v1/oauth/management/bill/uploadBatchCreateBillExcel",
    method: "post",
    data: data,
    "Content-Type": "multipart/form-data"
  });
}

// 批量新增帳單
export function batchCreateBill(data) {
  return webRequest({
    url: "/v1/oauth/management/bill/batchCreateBill",
    method: "post",
    data: data
  });
}

// 帳單列表
export function getFinancialBill() {
  return webRequest({
    url: "/v1/oauth/management/bill/record",
    method: "get"
  });
}
// 帳單列表V2
export function getFinancialBillV2(params) {
  return webRequest({
    url: "/v2/oauth/management/bill/record",
    method: "get",
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/apis/company/bill.js